import {
  Object3D,
  Euler,
  EventDispatcher,
  MathUtils,
  Quaternion,
  Vector3
} from 'three'

import * as MobileHelper from 'utility/MobileHelper'

const _zee = new Vector3(0, 0, 1)
const _euler = new Euler()
const _q0 = new Quaternion()
const _q1 = new Quaternion(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5)) // - PI/2 around the x-axis

const setObjectQuaternion = function (quaternion : any, alpha : any, beta: any, gamma : any, orient:any) {
  _euler.set(beta, alpha, -gamma, 'YXZ') // 'ZXY' for the device, but 'YXZ' for us
  quaternion.setFromEuler(_euler) // orient the device
  quaternion.multiply(_q1) // camera looks out the back of the device, not the top
  quaternion.multiply(_q0.setFromAxisAngle(_zee, -orient)) // adjust for screen orientation
}

class DeviceOrientationControls extends EventDispatcher {
  object : Object3D
  enabled : boolean
  deviceOrientation : any
  screenOrientation : number
  alphaOffset : number

  public onDeviceOrientationChangeEvent = (event:any) => {
    this.deviceOrientation = event
    this.updateOrentation(this.deviceOrientation)
  }

  protected updateOrentation = (event:DeviceOrientationEvent) => {
    const alpha = event.alpha ? MathUtils.degToRad(event.alpha) + this.alphaOffset : 0 // Z
    const beta = event.beta ? MathUtils.degToRad(event.beta) : 0 // X'
    const gamma = event.gamma ? MathUtils.degToRad(event.gamma) : 0 // Y''

    this.screenOrientation = MobileHelper.IsIOS() ? window.orientation : screen.orientation.angle // while window.orientation is depreciated, its still used by ios apparently
    const orient = this.screenOrientation ? MathUtils.degToRad(this.screenOrientation) : 0 // O

    setObjectQuaternion(this.object.quaternion, alpha, beta, gamma, orient)
  }

  public connect () : void {
    registeredControls.push(this)
    this.enabled = true
  }

  public disconnect () : void {
    registeredControls.slice(registeredControls.indexOf(this), 1)
    this.enabled = false
  }

  constructor (object : Object3D) {
    super()

    if (window.isSecureContext === false) {
      console.error('THREE.DeviceOrientationControls: DeviceOrientationEvent is only available in secure contexts (https)') // eslint-disable-line
    }

    this.object = object
    this.object.rotation.reorder('YXZ')

    this.enabled = true

    this.deviceOrientation = {}
    this.screenOrientation = 0

    this.alphaOffset = 0 // radians

    this.connect()
  }
}

const registeredControls : DeviceOrientationControls[] = []

function GlobalOnDeviceOrientationChangeEvent (event:any) {
  registeredControls.forEach(x => {
    x.onDeviceOrientationChangeEvent(event)
  })
}

if (MobileHelper.IsIOS() === false) {
  InitializeOrientationControlsForIos()
}

window.addEventListener('deviceorientation', (event) => {
  GlobalOnDeviceOrientationChangeEvent(event)
})

export function RequestDeviceOrientation (
  _callbackSuccess:()=>void,
  _callbackFail:()=>void) {
  try {
  // @ts-ignore
    DeviceOrientationEvent.requestPermission().then(response => {
      if (response === 'granted') {
        InitializeOrientationControlsForIos()
        _callbackSuccess()
      } else {
        _callbackFail()
      }
    })
      .catch(console.error) // eslint-disable-line
  } catch (error) {
    console.warn('DeviceOrientationEvent.requestPermission doesn\'t exist') // eslint-disable-line
    _callbackFail()
  }
}

function InitializeOrientationControlsForIos () {
  window.addEventListener('deviceorientation', (event) => {
    GlobalOnDeviceOrientationChangeEvent(event)
  })

  window.addEventListener('deviceorientation', GlobalOnDeviceOrientationChangeEvent)
}

export { DeviceOrientationControls }
